module.exports = __webpack_public_path__ + "img/w12-b1.25b3c808.jpg";